import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _types$SET_CURRENT_LA;

import * as types from './types';
export default (_types$SET_CURRENT_LA = {}, _defineProperty(_types$SET_CURRENT_LA, types.SET_CURRENT_LAYER, function (state, payload) {
  var currentState = state;
  currentState.item = payload.item;
  currentState.index = payload.index;
}), _defineProperty(_types$SET_CURRENT_LA, types.SET_LAYER_PRODUCTS, function (state, payload) {
  var currentState = state;
  currentState.products = payload;
}), _defineProperty(_types$SET_CURRENT_LA, types.RESET_LAYER_PRODUCTS, function (state, payload) {
  var currentState = state;
  currentState.products = payload;
}), _defineProperty(_types$SET_CURRENT_LA, types.SET_LOADING_LAYER, function (state, payload) {
  var currentState = state;
  currentState.loading = payload;
}), _defineProperty(_types$SET_CURRENT_LA, types.APPEND_ITEMS, function (state, payload) {
  var currentState = state;
  currentState.items.push(payload);
}), _types$SET_CURRENT_LA);